import store from '@/store'

export default {

    hourMinuteSecond(date){
        // Given timestamp
        const timestamp = new Date(date);

        // Get hour, minute, and second
        const hour = timestamp.getHours().toString().padStart(2, '0');
        const minute = timestamp.getMinutes().toString().padStart(2, '0');
        const second = timestamp.getSeconds().toString().padStart(2, '0');
        
        return `${hour}:${minute}:${second}`

    },

    changeDateFormat(date){

        if(this.isNullOrEmpty(date) || date == "null") { return "-" }

        if(date) {

            const month_names = [
                "Januari", "Februari", "Maret",
                "April", "Mei", "Juni",
                "Juli", "Agustus", "September",
                "Oktober", "November", "Desember"
            ];

            let year = date.slice(0, 4);
            let month = date.slice(5, 7);
            let day = date.slice(8, 10);
            let dayInt = parseInt(day, 10);
            let monthInt = parseInt(month, 10);

            return `${dayInt} ${month_names[monthInt-1]} ${year}`;
            
        }

        return '-';

    },

    changeDateFormatGetHour(date) {
        if(date){
            let clock = date.slice(11, 16)
            return `${clock} WIB`;
        }
        return '-';
    },

    formatTimestampToDateId(timestamp) {
        if (this.isNullOrEmpty(timestamp)) return '-';

        const date = new Date(Number(timestamp));
        if (isNaN(date.getTime())) return '-';

        const month_names = [
            "Januari", "Februari", "Maret",
            "April", "Mei", "Juni",
            "Juli", "Agustus", "September",
            "Oktober", "November", "Desember"
        ];

        return `${date.getDate()} ${month_names[date.getMonth()]} ${date.getFullYear()}`;
    },

    formatTimestampToDateTimeId(timestamp) {
        if (this.isNullOrEmpty(timestamp)) return '-';

        const date = new Date(Number(timestamp));
        if (isNaN(date.getTime())) return '-';

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${this.formatTimestampToDateId(timestamp)} ${hours}:${minutes} WIB`;
    },
    
    dusNumber(boxNumber){
        return boxNumber == 999 ? 'LD' : boxNumber;
    },

    addThousandSeparator(number){
        // const rounded =  Math.round(number * 100) / 100;
        if(number == 0) { return 0 }

        if(number){
            return `${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        }
        
        return '-';

    },

    removeThousandSeparator(num){
        if(num){
            let removeDotNum = ("" + num).replace(/\./g, "");
            if(isNaN(removeDotNum)){
                return ""
            }else{
                return Number(removeDotNum);
            }
        } else if(num == 0) return 0

        return "";
    },

    changeToValue(num){
        if(num){
            let removeDotNum = num.replace(/\./g, "");
            return removeDotNum;
        }
        return ""
    },

    makeQuery(page, size){
        let string = "?page="+page+"&size="+size
        return string
    },

    getAllCabang(){
        let getCabang = localStorage.getItem("cabang")
        let allCabang = JSON.parse(getCabang)
        return allCabang
    },

    getCabangId(){
        return localStorage.getItem("activeCabangId")
    },

    getCabangProvinceId(){
        return localStorage.getItem("activeCabangProvinceId")
    },

    setFlash(msg){
        localStorage.setItem('flash', msg)
    },

    getFlash(){
        let flash = localStorage.getItem('flash')
        localStorage.removeItem('flash')
        return flash
    },

    returnYears(){
        let currentYear = new Date().getFullYear()
        let arrYear = []
        let x = 2000
        while(x <= currentYear+2){
            arrYear.push(x)
            x++
        }
        return arrYear
    },

    createEmptyFile() {
        var f = new File([""], "blank.pgifile")
        return f
    },

    toastSucc(vue, msg, toastTitle='Sukses'){
        vue.$bvToast.toast(msg, {
          title: toastTitle,
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'success'
        })
    },

    toastErr(vue, msg, toastTitle='Gagal'){
        if (msg === 'Gagal memproses gambar, silahkan coba kembali!') {
            msg = 'Gambar tidak dapat diproses. Silakan ambil ulang foto atau gunakan gambar lain.'
        }
        vue.$bvToast.toast(msg, {
            title: toastTitle,
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'danger'
        })
    },

    parseError(vue, error, toastTitle = "Gagal", isToast = true) {

        console.log(error)

        let message = ""

        if(error.response && error.response.data.reason != null) {
            message = error.response.data.reason
        }
        else if(error.message.startsWith("timeout")) {
            message = "Gagal menghubungi server, periksa jaringan anda dan coba kembali! [ERR-TIMEOUT]"
        }
        else if (error.message == 'Network Error') {
            return;
        } else {
            message = error.message
        }

        if (message && message.includes("Parameter specified as non-null is null")) {
            message = 'Terjadi kesalahan. Silakan refresh browser dan coba lagi.'
        }

        if (isToast) {
            this.toastErr(vue, message, toastTitle)
        }

        return message
    },

    toastAlert(vue, msg, toastTitle='Alert'){
        vue.$bvToast.toast(msg, {
          title: toastTitle,
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'primary'
        })
    },

    isNotNullAndNotEmpty(input) {
        return input != null && input != '' && input.length != 0
    },

    isNullOrEmpty(input) {
        return input == null || input == ''
    },

    printPayload(payload) {

        for(var pair of payload.entries()) {
            console.log(pair[0] + ': ' + pair[1]); 
        }

    },

    resizeImage(base64Str, maxWidth = 1920, maxHeight = 1080){
        store.dispatch('loading/show')
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onerror = () => reject(new Error('Gagal membaca gambar'))
            img.src = base64Str
            img.onload = async () => {
                try {
                    let canvas = document.createElement('canvas')
                    const MAX_WIDTH = maxWidth
                    const MAX_HEIGHT = maxHeight
                    let width = img.width
                    let height = img.height

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width
                        width = MAX_WIDTH
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height
                        height = MAX_HEIGHT
                        }
                    }
                    canvas.width = width
                    canvas.height = height
                    let ctx = canvas.getContext('2d')
                    ctx.drawImage(img, 0, 0, width, height)
                    if (this.isBlankCanvas(canvas)) {
                        try {
                            const blob = await (await fetch(base64Str)).blob()
                            const bitmap = await createImageBitmap(blob, {
                                resizeWidth: Math.max(1, Math.round(width)),
                                resizeHeight: Math.max(1, Math.round(height)),
                                resizeQuality: 'high',
                                imageOrientation: 'from-image'
                            })
                            ctx.drawImage(bitmap, 0, 0, width, height)
                            bitmap.close()
                        } catch (e) {
                            return reject(new Error('Gagal membaca gambar'))
                        }
                        if (this.isBlankCanvas(canvas)) return reject(new Error('Foto hitam/kosong'))
                    }
                    let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)
                    if(newBase64Str.length < base64Str.length) {
                        resolve(newBase64Str)
                    } else {
                        resolve(base64Str)
                    }
                } catch (e) {
                    reject(e)
                }
            }
        }).finally(() => store.dispatch('loading/hide'))
    },

    buildAwsFileUrl(basePath, path) {
        if (this.isNullOrEmpty(path)) return ""
        if (/^https?:\/\//.test(path)) return path
        return `${String(basePath || "").replace(/\/$/, "")}/${String(path).replace(/^\//, "")}`
    },

    groupShipmentPhotos(basePath, photos) {
        const groups = []
        photos.forEach(photo => {
            const label = photo.category ? photo.category.name : 'Lainnya'
            let group = groups.find(group => group.label == label)
            if (!group) {
                group = { label, isVideo: Boolean(photo.category && photo.category.mediaRequirement && photo.category.mediaRequirement.type == 'VIDEO'), urls: [] }
                groups.push(group)
            }
            group.urls.push(this.buildAwsFileUrl(basePath, photo.path))
        })
        return groups
    },

    isBlankCanvas(canvas) {
        const data = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data
        for (let i = 0; i < data.length; i += 4 * 61) {
            if (data[i] > 10 || data[i + 1] > 10 || data[i + 2] > 10) return false
        }
        return true
    },

    getBasePagedQuery(page, size) {
        let string = "?page="+page+"&size="+size
        return string
    },
    
    validasiUmurNasabah(umur){
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1;
            let yearNow = today.getFullYear()
            var split = umur.split("-")
            let tahun = split[0]
            let bulan = split[1]
            let hari = split[2]
            var calculate = yearNow - 18

            if(calculate > tahun){
                return true
            }else if(calculate == tahun){
                if(bulan < mm){
                    return true
                }else if(bulan == mm){
                    if(hari <= dd){
                        return true
                        // return this.$helper.toastErr(this, "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai.")
                    }else{
                       return false
                        // return this.$helper.toastErr(this, "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai.")
                    }
                }else{
                    return false
                    // return this.$helper.toastErr(this, "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai.")
                }
            } else{
                return false
                // return this.$helper.toastErr(this, "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai.")
            }
    },

    validasiStnk(tanggal){
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yearNow = today.getFullYear()
        
        let bulanx
        let minus
        let tahunx

        var dateString
        var dateParts
        var dateObject


        if(mm < 6){
            minus = mm-6
            bulanx = 12 + minus 
            tahunx = yearNow - 1
            dateString = dd.toString()+'/'+bulanx.toString()+'/'+tahunx.toString()
            dateParts = dateString.split("/")
            dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
        }else{
            bulanx = mm - 6 ,
            dateString = dd.toString()+'/'+bulanx.toString()+'/'+yearNow.toString()
            dateParts = dateString.split("/")
            dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
        }

        let date = new Date(tanggal.toString())

        if(date != "Invalid Date"){
            if(date >= dateObject){
                return true
            }else{
                return false
            }
        }
    },

    formatTanggalDMY(date = new Date()){
        let currentTime = new Date(date);
        let day = currentTime.getDate();
        let month = currentTime.getMonth() + 1;
        let year = currentTime.getFullYear();

        // Tambahkan angka 0 di depan hari dan bulan jika perlu
        if (day < 10) {
        day = '0' + day;
        }
        if (month < 10) {
        month = '0' + month;
        }
    
        return `${day}-${month}-${year}`
    },

    formatTimestamp(date = new Date()){
        let currentTime = new Date(date);
        let day = currentTime.getDate();
        let month = currentTime.getMonth() + 1;
        let year = currentTime.getFullYear();

        // Tambahkan angka 0 di depan hari dan bulan jika perlu
        if (day < 10) {
        day = '0' + day;
        }
        if (month < 10) {
        month = '0' + month;
        }
    
        return `${year}-${month}-${day}`+ ' ' + this.waktu24()
    },

    waktu24(date= new Date()){
        const currentDate = new Date(date);
        const currentHours = String(currentDate.getHours()).padStart(2, '0');
        const currentMinutes = String(currentDate.getMinutes()).padStart(2, '0');
        const currentSeconds = String(currentDate.getSeconds()).padStart(2, '0');
        
        return `${currentHours}:${currentMinutes}:${currentSeconds}`;
                
    },

    formatThreeDigitNumber(number) {
        // Konversi ke string untuk mengukur panjang angka
        let numberString = String(number);
      
        // Tambahkan dua angka 0 di depan jika panjang kurang dari 3 digit
        while (numberString.length < 3) {
          numberString = '0' + numberString;
        }
      
        return numberString;
      },

      changeDateTimeFormat(dateStr) {
        const date = new Date(dateStr);
      
        const months = [
          "Januari", "Februari", "Maret", "April", "Mei", "Juni",
          "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ];
      
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
      
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
      
        return `${day} ${month} ${year}, ${hours}:${minutes}`;
    },
    formatDateAndHour(date) {
        if (!date) return '-';

        return `${this.changeDateFormat(date)} ${this.changeDateFormatGetHour(date)}`
    },
    isValidImei(imei) {
        if (!imei) return false;

        imei = String(imei).trim();

        return /^[A-Za-z0-9]{15}$/.test(imei);
    },

    validateBatasMasaPajak(inputTanggal) {
        if (!inputTanggal) {
            return { valid: false, message: "Silakan isi tanggal berlaku pajak STNK." };
        }

        const today = new Date();
        
        // 2 tahun
        const nextYear = today.getFullYear() + 2;

        const maxDate = new Date(nextYear, 11, 31);
        maxDate.setHours(0, 0, 0, 0);

        const selected = new Date(inputTanggal);
        selected.setHours(0, 0, 0, 0);

        if (selected.getTime() > maxDate.getTime()) {
            return {
                valid: false,
                message: `Tanggal pajak tidak boleh lebih dari ${maxDate.toLocaleDateString("id-ID")}.`
            };
        }

        return { valid: true, message: "Tanggal pajak sudah sesuai." };
    },

    validateArrayHaveValue(array, key) {
        return array.every(item => item[key] !== null && item[key] !== undefined && item[key] !== "");
    },

    async uploadPresigned({
        vue,
        path,
        params = {},
        fileUpload,
        contentType = 'image',
        onUploadProgress = null,
        useXhr = false,
    }) {
        const paramsUrl = {
            contentType,
            ...params,
        }
        try {
            const presRes = await vue.$axios.get(path, {
                params: paramsUrl,
            });

            const d = presRes.data || {};
            const nestedData = d.data || {};
            const presignedUrl = typeof d === "string"
            ? d
            : d.url ||
            d.name ||
            d.presignedUrl ||
            d.presignedname ||
            nestedData.url ||
            nestedData.name;

            if (!presignedUrl) throw new Error("Gagal mendapatkan presigned URL");

            if (useXhr) {
                await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();

                    xhr.open("PUT", presignedUrl);
                    xhr.setRequestHeader("Content-Type", contentType);

                    xhr.upload.onprogress = event => {
                        if (!event.lengthComputable || typeof onUploadProgress !== "function") return;
                        onUploadProgress(Math.round((event.loaded / event.total) * 100));
                    };

                    xhr.onload = () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            if (typeof onUploadProgress === "function") onUploadProgress(100);
                            resolve();
                            return;
                        }

                        reject(new Error(`Gagal upload file [${xhr.status}]`));
                    };

                    xhr.onerror = () => reject(new Error("Gagal upload file"));
                    xhr.onabort = () => reject(new Error("Upload dibatalkan"));
                    xhr.send(fileUpload);
                });
            } else {
                await fetch(presignedUrl, {
                    method: "PUT",
                    headers: { "Content-Type": contentType },
                    body: fileUpload,
                });
            }

            const publicUrl = presignedUrl.split("?")[0];

            return {
                success: true,
                publicUrl,
            };
        } catch (error) {
            this.parseError(vue, error)
            return {
                success: false,
                error: error,
            };
        }
    },
    
    hasPermissionMenuChildren(code) {
        const menuChildren = localStorage.getItem("menuChildren");
        if (!menuChildren) return false;

        const menuArray = menuChildren.split(",");
        return menuArray.includes(code);
    },

    formatNameAndNik(name) {
        if (!name || typeof name !== "string") return "";

        const parts = name.split(" - ");
        if (parts.length < 2) {
            return name || "";
        }

        const [username, fullname] = parts;
        return `${fullname} (${username})`;
    },

    isInvalidDateRange(startDate, endDate) {
        if (!startDate || !endDate) return false
        return new Date(startDate) > new Date(endDate)
    },

    createSafeFileCopy(file) {
        if (!(file instanceof File)) {
            return file; 
        }

        return new File(
            [file],
            file.name,
            {
                type: file.type,
                lastModified: file.lastModified,
            }
        );
    },

    getParams(key) {
        const params = new URLSearchParams(window.location.search);
        return params.get(key) || '';
    },

    setParams(router, queryObj) {
        const newQuery = { ...router.currentRoute.query, ...queryObj };

        Object.keys(newQuery).forEach(key => {
            if (newQuery[key] === '' || newQuery[key] === null || newQuery[key] === undefined) {
                delete newQuery[key];
            }
        });

        router.push({ query: newQuery }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.log(err);
        });
    },

    clearParams(router, keys) {
        const newQuery = { ...router.currentRoute.query };
        
        if (Array.isArray(keys)) {
            keys.forEach(key => delete newQuery[key]);
        } else {
            delete newQuery[keys];
        }

        router.push({ query: newQuery }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.log(err);
        });
    },

    clearAllParams(router) {
        router.push({ query: {} }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.log(err);
        });
    }
}
